import React from 'react';
import { View } from 'react-native';

import Text from './Text';
import Image from './Image';

import { PADDING1, pOrT } from '../styleConstants';

type Props = {
  title: string;
  children: any;
  style?: any;
  menuItemsLength?: number;
};

const HEIGHT = pOrT(200, 200);
export const WIDTH = pOrT(200, 250);

const Card = ({ title, children, style }: Props) => (
  <View style={style}>
    <Image
      style={{
        width: WIDTH,
        height: HEIGHT,
        position: 'absolute',
      }}
      resizeMode="stretch"
      source={require('../../assets/images/paper2.png')}
    />
    <View
      style={[
        {
          width: WIDTH,
          height: HEIGHT,
          padding: PADDING1,
        },
      ]}
    >
      <Text bold style={{ marginBottom: 5, fontSize: pOrT(12, 16) }}>
        {title}
      </Text>
      {children}
    </View>
  </View>
);

export default Card;
